module.exports = "<navbar></navbar><div id=content flex-item=grow-1><router-view></router-view></div><foot></foot>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/App.vue
// module id = 354
// module chunks = 0